import { Component, OnInit } from '@angular/core'
import { WelcomePackageService } from '../welcome-package.service'
import { Observable, merge } from 'rxjs'
import { ActivatedRoute, Router } from '@angular/router'
import { Location } from '@angular/common'
import { TranslationService } from '@spartacus/core'
import { BreadcrumbService } from '../../../shared/components/breadcrumb/breadcrumb.service'
const EQUIPMENT_OPTIONS = [
  {
    label: 'Serial Number',
    value: 'SERIAL_NO',
  },
  // {
  //   label: 'Purchase Order Number',
  //   value: 'PO_NO'
  // },
  // {
  //   label: 'Sales Order Number',
  //   value: 'SALES_ORDER_NO'
  // }
]
@Component({
  standalone: false,
  selector: 'vs-search-by-serial',
  templateUrl: './search-by-serial.component.html',
  styleUrls: ['./search-by-serial.component.scss'],
})
export class SearchBySerialComponent implements OnInit {
  public term = ''
  public dataSource$: Observable<any>
  public dataSource
  public showTable: boolean
  loading = true
  public showSpinner
  public noData: boolean
  public noBoMData: boolean
  crntPage = 0
  PAGE_SIZE = 50
  welcomePackageData$: Observable<any>
  welcomePackageData: any
  findEquipmentByOptions = EQUIPMENT_OPTIONS
  findEquipmentBy = this.findEquipmentByOptions[0].value
  notFound
  constructor(
    private welcomePackageService: WelcomePackageService,
    private breadCrumbService: BreadcrumbService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslationService,
    private location: Location
  ) {
    this.showTable = false
    this.noData = false
    this.showSpinner = false
    this.noBoMData = false
  }
  loadData() {
    this.term = ''
    sessionStorage.setItem('searchType', this.findEquipmentBy)
  }
  ngOnInit(): void {
    sessionStorage.setItem('searchType', this.findEquipmentBy)

    this.breadCrumbService.setBreadCrumbs([])
    this.translate
      .translate('welcomePackage.equipmentSearch')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )
      
    // this.route.paramMap.subscribe((value: any) => {
    //   const id = value.params.id;
    //   this.notFound = id;
    //   if(id){
    //     this.showSpinner = true;
    //   }
    //   this.dataSource$=this.welcomePackageService.getSearchResult(id,this.crntPage,this.PAGE_SIZE,this.findEquipmentBy)
    //   this.dataSource$.subscribe((res) => {
    //     this.dataSource = res;
    //     if(this.dataSource.serialNumberSearchList==undefined){
    //       this.noData=true;
    //       if(res?.serialNoSearchErrorResponse?.additionalInfo != "No data available for this serial number in WP"
    //       && res?.serialNoSearchErrorResponse?.additionalInfo !="invalid data"){
    //         // this.noBoMData = true;
    //         this.showTable = false;
    //         this.noData=false
    //       }
    //     }else{
    //       this.showTable = true;
    //       this.noData=false;
    //       this.noBoMData = false;
    //     }     
    //   },(err) => {
    //     if(id?.length>0){
    //       this.noBoMData = true;
    //       this.showTable = false;
    //       this.noData=false
    //       this.showSpinner = false;
    //     }
    //     // Do stuff whith your error
    //   },);
    // })
  }

  public modelChange(str): void {
    this.term = str.value;
    if(str.value.length>0 && str.value.trim.length==0){
    //this.router.navigate(["welcome-package/serial-search",str.value]);
    this.router.navigate(["welcome-package/bom/",str.value]);
    this.showSpinner = true;
    // this.dataSource$=this.welcomePackageService.getSearchResult(str.value,this.crntPage,this.PAGE_SIZE,this.findEquipmentBy
    // )
    // this.dataSource$.subscribe(res => {
    //   this.dataSource = res;
    //   if(this.dataSource.serialNumberSearchList==undefined){
    //     this.noData=true;
    //     str.value="";
    //     if(res?.serialNoSearchErrorResponse?.additionalInfo != "No data available for this serial number in WP"
    //     && res?.serialNoSearchErrorResponse?.additionalInfo !="invalid data"){
    //       // this.noBoMData = true;
    //       this.showTable = false;
    //       this.noData=false
    //     }
    //   }else{
    //     this.showTable = true;
    //     this.noData=false;
    //     // this.noBoMData = false;
    //     str.value="";
    //   }     
    // },err => {
    //   this.noBoMData = true;
    //   this.showTable = false;
    //   this.noData=false
    //   this.showSpinner = false;
    // },);
    // this.showTable = false;
  }
  }

  public keyUp(str, event){
    if(event.keyCode === 13){
      this.router.navigate(["welcome-package/serial-search", str.value]);
      this.showSpinner = true;
      this.dataSource$=this.welcomePackageService.getSearchResult(str.value,this.crntPage,this.PAGE_SIZE,this.findEquipmentBy)
      this.dataSource$.subscribe(res => {
          this.dataSource = res;
          if(this.dataSource.serialNumberSearchList==undefined){
            this.noData=true;
            str.value="";
            if(res?.serialNoSearchErrorResponse?.additionalInfo != "No data available for this serial number in WP"
            && res?.serialNoSearchErrorResponse?.additionalInfo !="invalid data"){
              // this.noBoMData = true;
              this.showTable = false
              this.noData = false
            }
          } else {
            this.showTable = true
            this.noData = false
            // this.noBoMData = false;
            str.value = ''
          }
        },
        (err) => {
          this.noBoMData = true
          this.showTable = false
          this.noData = false
          this.showSpinner = false
        }
      )
      this.showTable = false
    }
  }
}
